<template>
	<app-page>
		<app-heading title="Roles">
			<template v-slot:left>
				<app-button v-if="$ravello.can('role.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'api-role', params: { role: 'new' } }"
				>Add Role</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="roles"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchRoles"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('role.put')"
							color="secondary"
							:to="{ name: 'api-role', params: { role: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('role.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove role <b>${item.name}</b>?`"
							title="Remove Role"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'api-role', params: { role: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			roles: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchRoles(pagination) {
			const request = this.$ravello.graphql('roles')
				.fields(['_id', 'name'])
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.roles = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('roles')
					.to(id)
					.delete()
				this.$notifications.pushAlert('success', 'Role successfully deleted')
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
